import { redirectOnStudybuddyVariant } from 'frontend/shared/javascripts/modules/studybuddy_variant'

up.compiler('[data-studybuddy-path]', (element: HTMLElement) => {
  const path = element.dataset.studybuddyPath!

  return redirectOnStudybuddyVariant('b', () => path)
})
